import DatalistInput from 'react-datalist-input';
import 'react-datalist-input/dist/styles.css';

const Entidad_Sucursales=({validaentidadmuellaje,nombreentidadmuellaje,handleEntidad,ConsultarEntidad,listaentidades,readOnlyentidadmuellaje,intCusDocStatusId,estatus,limpiarMuellaje, muellaje_rfc,muellaje_cod_post_id})=>{
    return(
        <>
            <div className="row my-2">
                <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                    <div className="row "> 
                        <div className={`col-11 p-0 m-0 ${validaentidadmuellaje}`} >
                            <DatalistInput 
                                placeholder="Seleccione muellaje"
                                value={nombreentidadmuellaje} 
                                onSelect={(item) => { handleEntidad(item.strrfc, item.intBillId, item.idcompany, item.value,2)} }
                                onKeyDown={(ev)=>{ ConsultarEntidad(ev, ev.target.value) }}

                                style={{border:"none"}}
                                label="FACTURAR MUELLAJE A:"
                                showLabel={true}
                                items={  
                                    listaentidades?
                                        listaentidades.map((el)=>(
                                            {idtype: el.intEntityTypeId, idcompany: el.intCompanyEntityId , value: el.intEntityTypeId+" - "+ el.intCompanyEntityId+" : "+el.strCompanyName }
                                        )): [{idtype:0, idcompany:0 , value: "Escriba el nombre de un entidad" }]
                                }
                                labelProps={{
                                    className:"m-0 p-0",
                                }} 
                                inputProps={{
                                    className:('form-control form-control-sm '+validaentidadmuellaje),
                                    readOnly: readOnlyentidadmuellaje,
                                }}
                                listboxProps={{ 
                                    className:(' listboxProps'),
                                }}
                            />
                        </div>
                        {intCusDocStatusId === 0 || estatus == "REJ" ?
                        <div className="col-1 btn_borrar_item_lista mb-1 pb-1">
                            <button className="btn-close " title="BORRAR CONTENIDO" onClick={limpiarMuellaje}></button>
                        </div>:<></>}
                    </div>  
                </div>

                <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 mx-1">
                    <div className="row "> 
                        <div className={`col-12 p-0 m-0 ${validaentidadmuellaje}`} >
                            <label className="m-0 p-0">RFC: </label>
                            <label className="form-control form-control-sm ">{muellaje_rfc}</label>   
                              
                        </div> 
                    </div>  
                </div>

                <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 mx-1">
                    <div className="row "> 
                        <div className={`col-12 p-0 m-0 ${validaentidadmuellaje}`} >
                            <label className="m-0 p-0">CÓDIGO POSTAL: </label>
                            <label className="form-control form-control-sm ">{muellaje_cod_post_id}</label>   
                              
                        </div> 
                    </div>  
                </div>

                {/*<div className="col-lg-2 col-md-2 col-sm-12 col-xs-12 mx-1">
                    <div className="row "> 
                        <div className={`col-12 p-0 m-0 ${validaentidadmuellaje}`} >
                            <label className="m-0 p-0">SUCURSAL: </label>
                            <label className="form-control form-control-sm "></label>   
                              
                        </div> 
                    </div>  
                </div>*/}

            </div> 
        </>
    )
}


export default Entidad_Sucursales;